import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, map, Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-header',
  template: `
  <nav class="navbar navbar-expand-md container-fluid">
    <span class="navbar-brand mb-0 h1">
      <img src="/assets/logo.png" alt="Stryker">
    </span>
    <div class="collapse navbar-collapse">
      <span class="navbar-text m-auto text-body fw-semibold">
        {{appName}}
      </span>
      @let user = $user | async;
      @if (user) {
        <span class="navbar-text text-body fw-light">
          Welcome {{user}}
        </span>
      }
    </div>
  </nav>
  `,
  styles: `
  .navbar-brand>img {
    max-width: 100px;
  }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe]
})
export class HeaderComponent {
  private readonly msalService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);

  /**
   * Application display name.
   */
  protected readonly appName = environment.appName;

  /**
   * Current user display name.
   */
  protected readonly $user: Observable<string> = this.msalBroadcastService.inProgress$.pipe(
    takeUntilDestroyed(),
    filter(status => status === InteractionStatus.None),
    map(_ => this.getUserName())
  );

  /**
   * Retrieves current user display name.
   *
   * @returns Current user display name.
   */
  private getUserName(): string {
    const account = this.msalService.instance.getActiveAccount();

    if (account?.idTokenClaims) {
      const givenName = account.idTokenClaims['given_name'] as string;
      const familyName = account.idTokenClaims['family_name'] as string;

      return `${givenName} ${familyName}`.trim();
    }

    return '';
  }
}
